// extracted by mini-css-extract-plugin
export default {"aboutYou":"aboutYou__2mSjY","checkpointLabel":"checkpointLabel__W87sl"};